import React from 'react'
import ComingSoon from '../../components/comingSoon/ComingSoon'

function Home() {
  return (
    <>
        <div className="container">
            <div className="home">
                <ComingSoon />
            </div>
        </div>
    </>
  )
}

export default Home